import { Compass, BookOpen, MapPin, Users, Star, FileText, Camera, BookUser, MessageSquare, Newspaper, Map, Check, CircleDot, Building2, Database, Zap } from "lucide-react";

// Mock data stores icon names as plain strings (JSON-serializable, mirrors
// what a real API response would send) — this maps them to the actual
// lucide-react components for stat cards / quick links / section rails.
const TSP_ICONS = { Compass, BookOpen, MapPin, Users, Star, FileText, Camera, BookUser, MessageSquare, Newspaper, Map, Check, CircleDot, Building2, Database, Zap };

export default TSP_ICONS;
